<template>
  <div class="container pb-16">
    <navigation-drawer :titles="title"/>
    <div class="row">
      <div class="col-md-6 col-12">
        <v-card>
          <div class="d-flex justify-content-center">
            <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                   name="ImageFileUrl" type="file"
                   @change="attachmentSelected">
            <div v-if="selectedImage !==null">
              <img
                  :src="selectedImage"
                  class="img-fluid p-3" alt="تصویر اصلی"/>
            </div>
            <div v-else class="no-pic-height">عکسی انتخاب نشده است</div>
          </div>
          <div class="p-3 text-center">
            <v-btn
                dark
                elevation="0"
                class="primary rounded-lg"
                @click="$refs.inputUpload.click()">
              انتخاب عکس
            </v-btn>
          </div>
        </v-card>
      </div>
      <div class="col-md-6 col-12">
        <div class="mb-2 mr-1">لینک</div>
        <v-text-field
            v-model="bannerLink"
            solo
            background-color="whiteColor"
            flat
            class="rounded-lg mt-3"
        >
        </v-text-field>
        <div class="mb-2 mr-1">توضیحات</div>
        <editor-content :editor="bannerDescription" class="text-editor"/>
      </div>
      <div class="col-12 d-flex justify-content-center rounded-lg">
        <v-checkbox hide-details class="white-main-bg rounded-lg px-3" v-model="isActive" color="primary">
          <template slot="label">
            <span class="mt-2">فعال</span>
          </template>
        </v-checkbox>
      </div>
      <div class="col-12 mt-3 text-center">
        <v-btn v-if="isNew" color="primary" class="rounded-lg" large dark
               @click="defineBanner">
          <span class="font16px">انجام</span>
        </v-btn>
        <v-btn v-else color="primary" class="rounded-lg" large dark
               @click="editBanner">
          <span class="font16px">ویرایش</span>
        </v-btn>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import NavigationDrawer from "@/Admin/components/navigationDrawer";
import {Editor, EditorContent} from 'tiptap';


export default {
  name: "defineBanner",
  components: {NavigationDrawer, EditorContent},
  metaInfo() {
    return {
      title: ' ادمین-' + this.newsTitle
    }
  },
  data: () => ({
    newsTitle: null,
    showResultDialog: false,
    dialogResult: null,
    showLoaderDialog: false,
    selectedImage: null,
    title: null,
    isNew: true,
    bannerDescription: null,
    isActive: false,
    bannerLink: null,
    hasPhoto: false,
  }),
  mounted() {
    this.$convertFarsiNumber()
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/'})
    }
    if (this.$route.query.isNew === 'true') {
      this.isNew = true
      this.bannerDescription = new Editor({
        content: '',
      })
      this.title = 'تعریف بنر'
      this.newsTitle = 'تعریف بنر'
    } else {
      this.title = 'ویرایش بنر'
      this.newsTitle = 'ویرایش بنر'
      this.getData()
      this.isNew = false
    }
  },
  methods: {
    attachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.hasPhoto = false;
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImage = fr.result
          this.selectedImageFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.selectedImageFilePath = null;
      }
    },
    defineBanner() {
      let resStatus = null

      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      if (this.bannerDescription !== null) {
        formdata.append("Description", this.bannerDescription.getHTML());
      }
      formdata.append("IsActive", this.isActive);
      formdata.append("ImageFileUrl", this.selectedImageFilePath);
      // formdata.append("TypeBaner", "1");
      if (this.bannerLink !== null) {
        formdata.append("Link", this.bannerLink);
      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/DefineBanner", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 401) {
              this.showLoaderDialog = false
              this.$router.replace({path: '/Admin/Home'})
            }
            if (resStatus === 200) {
              this.showLoaderDialog = false
              this.dialogResult = result
              this.showResultDialog = true
              this.$router.push({path: 'listBanners'})
            } else {
              this.showLoaderDialog = false
              this.dialogResult = result
              this.showResultDialog = true
            }

          })
          .catch(error => console.log('error', error));
    },
    editBanner() {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("BanerID", this.$route.query.id);
      if (this.bannerDescription !== null) {
        formdata.append("Description", this.bannerDescription.getHTML());
      }
      formdata.append("IsActive", this.isActive);
      if (this.hasPhoto) {
        formdata.append("FileUrl", this.selectedImage);
      } else if (this.selectedImageFilePath !== null) {
        formdata.append("ImageFileUrl", this.selectedImageFilePath);
      }
      // formdata.append("TypeBaner", "1");
      if (this.bannerLink !== null) {
        formdata.append("Link", this.bannerLink);

      }

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditBanner", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
            this.$router.push({path: 'listBanners'})
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditBanner?bannerId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.bannerDescription = new Editor({
              content: json.Description,
            })
            this.bannerLink = json.Link
            this.selectedImage = json.FileUrl
            if (json.FileUrl !== null) {
              this.hasPhoto = true
            }
            this.isActive = json.IsActive
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>